/* The words the app's names are made of, written in the reader's script.
 *
 * utils/localNames reads these first and falls back to spelling by sound. Telugu is the
 * pivot: a word written here in Telugu is turned into Kannada, Hindi and Tamil by
 * utils/localNames, letter by letter, so each word is written once. Where a language
 * spells a word its own way, the entry gives that language too ({ te, hi, ta, kn }).
 * Keys are lower case. Display only - no record is ever changed.
 */

/* The cities we list, in each language, as their own people write them. Every one is
   checked by backend/tests/localNames.test.mjs to sound like its English name, so the
   city search (utils/cities) finds it too. [te, hi, ta, kn] */
export const CITY_NATIVE = {
  Adoni: ["ఆదోని", "आदोनी", "ஆதோனி", "ಆದೋನಿ"],
  Amalapuram: ["అమలాపురం", "अमलापुरम", "அமலாபுரம்", "ಅಮಲಾಪುರಂ"],
  Amaravati: ["అమరావతి", "अमरावती", "அமராவதி", "ಅಮರಾವತಿ"],
  Anakapalle: ["అనకాపల్లి", "अनकापल्ली", "அனகாபள்ளி", "ಅನಕಾಪಲ್ಲಿ"],
  Anantapur: ["అనంతపురం", "अनंतपुर", "அனந்தபூர்", "ಅನಂತಪುರ"],
  Bapatla: ["బాపట్ల", "बापटला", "பாபட்லா", "ಬಾಪಟ್ಲ"],
  Bhimavaram: ["భీమవరం", "भीमावरम", "பீமாவரம்", "ಭೀಮಾವರಂ"],
  Chilakaluripet: ["చిలకలూరిపేట", "चिलकलूरिपेट", "சிலகலூரிப்பேட்டை", "ಚಿಲಕಲೂರಿಪೇಟೆ"],
  Chittoor: ["చిత్తూరు", "चित्तूर", "சித்தூர்", "ಚಿತ್ತೂರು"],
  Dharmavaram: ["ధర్మవరం", "धर्मावरम", "தர்மாவரம்", "ಧರ್ಮಾವರಂ"],
  Eluru: ["ఏలూరు", "एलुरु", "ஏலூரு", "ಏಲೂರು"],
  Gooty: ["గుత్తి", "गूटी", "கூட்டி", "ಗುತ್ತಿ"],
  Gudur: ["గూడూరు", "गुडूर", "கூடூர்", "ಗೂಡೂರು"],
  Guntur: ["గుంటూరు", "गुंटूर", "குண்டூர்", "ಗುಂಟೂರು"],
  Hindupur: ["హిందూపురం", "हिंदूपुर", "ஹிந்துபூர்", "ಹಿಂದೂಪುರ"],
  Jaggaiahpet: ["జగ్గయ్యపేట", "जग्गय्यपेट", "ஜக்கய்யப்பேட்டை", "ಜಗ್ಗಯ್ಯಪೇಟೆ"],
  Jammalamadugu: ["జమ్మలమడుగు", "जम्मलमडुगु", "ஜம்மலமடுகு", "ಜಮ್ಮಲಮಡುಗು"],
  Kadapa: ["కడప", "कडपा", "கடப்பா", "ಕಡಪ"],
  Kakinada: ["కాకినాడ", "काकीनाडा", "காக்கிநாடா", "ಕಾಕಿನಾಡ"],
  Kandukur: ["కందుకూరు", "कंदुकूर", "கந்துகூர்", "ಕಂದುಕೂರು"],
  Kavali: ["కావలి", "कावली", "காவலி", "ಕಾವಲಿ"],
  Kurnool: ["కర్నూలు", "कुर्नूल", "கர்நூல்", "ಕರ್ನೂಲು"],
  Machilipatnam: ["మచిలీపట్నం", "मछलीपट्टनम", "மசூலிப்பட்டினம்", "ಮಚಲಿಪಟ್ಟಣ"],
  Madanapalle: ["మదనపల్లె", "मदनपल्ले", "மதனப்பள்ளி", "ಮದನಪಲ್ಲಿ"],
  Markapur: ["మార్కాపురం", "मारकापुर", "மார்க்காபூர்", "ಮಾರ್ಕಾಪುರ"],
  Nandyal: ["నంద్యాల", "नंद्याल", "நந்தியால்", "ನಂದ್ಯಾಲ"],
  Narasaraopet: ["నరసరావుపేట", "नरसरावपेट", "நரசராவ்பேட்டை", "ನರಸರಾವುಪೇಟೆ"],
  Nellore: ["నెల్లూరు", "नेल्लोर", "நெல்லூர்", "ನೆಲ್ಲೂರು"],
  Ongole: ["ఒంగోలు", "ओंगोल", "ஓங்கோல்", "ಒಂಗೋಲು"],
  Palasa: ["పలాస", "पलासा", "பலாசா", "ಪಲಾಸ"],
  Piduguralla: ["పిడుగురాళ్ల", "पिडुगुराल्ला", "பிடுகுராள்ளா", "ಪಿಡುಗುರಾಳ್ಳ"],
  Proddatur: ["ప్రొద్దుటూరు", "प्रोद्दुटूर", "புரொத்தட்டூர்", "ಪ್ರೊದ್ದುಟೂರು"],
  Puttaparthi: ["పుట్టపర్తి", "पुट्टपर्थी", "புட்டபர்த்தி", "ಪುಟ್ಟಪರ್ತಿ"],
  Rajahmundry: ["రాజమండ్రి", "राजमुंदरी", "ராஜமுந்திரி", "ರಾಜಮಂಡ್ರಿ"],
  Rayachoti: ["రాయచోటి", "रायचोटी", "ராயச்சோட்டி", "ರಾಯಚೋಟಿ"],
  Srikakulam: ["శ్రీకాకుళం", "श्रीकाकुलम", "ஸ்ரீகாகுளம்", "ಶ್ರೀಕಾಕುಳಂ"],
  Tadepalligudem: ["తాడేపల్లిగూడెం", "ताडेपल्लीगुडेम", "தாடேபள்ளிகூடெம்", "ತಾಡೇಪಲ್ಲಿಗೂಡೆಂ"],
  Tadipatri: ["తాడిపత్రి", "ताडिपत्री", "தாடிபத்ரி", "ತಾಡಿಪತ್ರಿ"],
  Tanuku: ["తణుకు", "तणुकु", "தணுக்கு", "ತಣುಕು"],
  Tenali: ["తెనాలి", "तेनाली", "தெனாலி", "ತೆನಾಲಿ"],
  Tirupati: ["తిరుపతి", "तिरुपति", "திருப்பதி", "ತಿರುಪತಿ"],
  Tuni: ["తుని", "तुनी", "துனி", "ತುನಿ"],
  Vijayawada: ["విజయవాడ", "विजयवाड़ा", "விஜயவாடா", "ವಿಜಯವಾಡ"],
  Visakhapatnam: ["విశాఖపట్నం", "विशाखापत्तनम", "விசாகப்பட்டினம்", "ವಿಶಾಖಪಟ್ಟಣಂ"],
  Vizianagaram: ["విజయనగరం", "विजयनगरम", "விஜயநகரம்", "ವಿಜಯನಗರಂ"],
  Yemmiganur: ["ఎమ్మిగనూరు", "येम्मिगनूर", "எம்மிகனூர்", "ಎಮ್ಮಿಗನೂರು"],
  Adilabad: ["ఆదిలాబాద్", "आदिलाबाद", "அதிலாபாத்", "ಆದಿಲಾಬಾದ್"],
  Armoor: ["ఆర్మూరు", "आर्मूर", "ஆர்மூர்", "ಆರ್ಮೂರು"],
  Asifabad: ["ఆసిఫాబాద్", "आसिफाबाद", "ஆசிபாபாத்", "ಆಸಿಫಾಬಾದ್"],
  Badepally: ["బాడేపల్లి", "बाडेपल्ली", "பாடேபள்ளி", "ಬಾಡೇಪಲ್ಲಿ"],
  Bhadrachalam: ["భద్రాచలం", "भद्राचलम", "பத்ராசலம்", "ಭದ್ರಾಚಲಂ"],
  Bhongir: ["భువనగిరి", "भोंगीर", "போங்கிர்", "ಭುವನಗಿರಿ"],
  Bodhan: ["బోధన్", "बोधन", "போதன்", "ಬೋಧನ್"],
  Devarakonda: ["దేవరకొండ", "देवरकोंडा", "தேவரகொண்டா", "ದೇವರಕೊಂಡ"],
  Gadwal: ["గద్వాల్", "गद्वाल", "கத்வால்", "ಗದ್ವಾಲ್"],
  Hyderabad: ["హైదరాబాద్", "हैदराबाद", "ஹைதராபாத்", "ಹೈದರಾಬಾದ್"],
  Jagitial: ["జగిత్యాల", "जगित्याल", "ஜகித்யால்", "ಜಗಿತ್ಯಾಲ"],
  Jangaon: ["జనగామ", "जनगांव", "ஜனகாம்", "ಜನಗಾಮ"],
  Jagtial: ["జగిత్యాల", "जगतियाल", "ஜக்தியால்", "ಜಗಿತ್ಯಾಲ"],
  Kamareddy: ["కామారెడ్డి", "कामारेड्डी", "காமாரெட்டி", "ಕಾಮಾರೆಡ್ಡಿ"],
  Karimnagar: ["కరీంనగర్", "करीमनगर", "கரீம்நகர்", "ಕರೀಂನಗರ"],
  Khammam: ["ఖమ్మం", "खम्मम", "கம்மம்", "ಖಮ್ಮಂ"],
  Korutla: ["కోరుట్ల", "कोरुटला", "கோருட்லா", "ಕೋರುಟ್ಲ"],
  Kothagudem: ["కొత్తగూడెం", "कोत्तागुडेम", "கொத்தகூடெம்", "ಕೊತ್ತಗೂಡೆಂ"],
  Kyathampalle: ["క్యాతంపల్లి", "क्यातमपल्ली", "க்யாதம்பள்ளி", "ಕ್ಯಾತಂಪಲ್ಲಿ"],
  Mahabubabad: ["మహబూబాబాద్", "महबूबाबाद", "மகபூபாபாத்", "ಮಹಬೂಬಾಬಾದ್"],
  Mahabubnagar: ["మహబూబ్‌నగర్", "महबूबनगर", "மகபூப்நகர்", "ಮಹಬೂಬ್‌ನಗರ"],
  Mancherial: ["మంచిర్యాల", "मंचेरियाल", "மஞ்சிரியால்", "ಮಂಚಿರ್ಯಾಲ"],
  Medak: ["మెదక్", "मेदक", "மேதக்", "ಮೆದಕ್"],
  Miryalaguda: ["మిర్యాలగూడ", "मिर्यालगुडा", "மிர்யாலகூடா", "ಮಿರ್ಯಾಲಗೂಡ"],
  Nalgonda: ["నల్గొండ", "नलगोंडा", "நல்கொண்டா", "ನಲ್ಗೊಂಡ"],
  Narayanpet: ["నారాయణపేట", "नारायणपेट", "நாராயண்பேட்டை", "ನಾರಾಯಣಪೇಟೆ"],
  Nirmal: ["నిర్మల్", "निर्मल", "நிர்மல்", "ನಿರ್ಮಲ್"],
  Nizamabad: ["నిజామాబాద్", "निज़ामाबाद", "நிஜாமாபாத்", "ನಿಜಾಮಾಬಾದ್"],
  Palwancha: ["పాల్వంచ", "पालवंचा", "பால்வஞ்சா", "ಪಾಲ್ವಂಚ"],
  Peddapalli: ["పెద్దపల్లి", "पेद्दापल्ली", "பெத்தபள்ளி", "ಪೆದ್ದಪಲ್ಲಿ"],
  Ramagundam: ["రామగుండం", "रामागुंडम", "ராமகுண்டம்", "ರಾಮಗುಂಡಂ"],
  Sangareddy: ["సంగారెడ్డి", "संगारेड्डी", "சங்காரெட்டி", "ಸಂಗಾರೆಡ್ಡಿ"],
  Secunderabad: ["సికింద్రాబాద్", "सिकंदराबाद", "செகந்திராபாத்", "ಸಿಕಂದರಾಬಾದ್"],
  Siddipet: ["సిద్దిపేట", "सिद्दिपेट", "சித்திப்பேட்டை", "ಸಿದ್ದಿಪೇಟೆ"],
  Siricilla: ["సిరిసిల్ల", "सिरसिल्ला", "சிரிசில்லா", "ಸಿರಿಸಿಲ್ಲ"],
  Suryapet: ["సూర్యాపేట", "सूर्यापेट", "சூர்யாபேட்டை", "ಸೂರ್ಯಾಪೇಟೆ"],
  Tandur: ["తాండూరు", "तांडूर", "தாண்டூர்", "ತಾಂಡೂರು"],
  Vikarabad: ["వికారాబాద్", "विकाराबाद", "விகாராபாத்", "ವಿಕಾರಾಬಾದ್"],
  Wanaparthy: ["వనపర్తి", "वनपर्ती", "வனபர்த்தி", "ವನಪರ್ತಿ"],
  Warangal: ["వరంగల్", "वारंगल", "வாரங்கல்", "ವರಂಗಲ್"],
  Yellandu: ["ఇల్లందు", "इल्लंदु", "இல்லந்து", "ಇಲ್ಲಂದು"],
  Zaheerabad: ["జహీరాబాద్", "ज़हीराबाद", "ஜஹீராபாத்", "ಜಹೀರಾಬಾದ್"],
};

/* People's names: the most common first names and family names in Andhra Pradesh and
   Telangana (no one's own record - a rare name is spelled by sound). Telugu, which the
   other scripts follow; an entry that another language spells its own way gives it. */
export const NAME_WORDS = {
  aakash: "ఆకాష్", abdul: "అబ్దుల్", abhi: "అభి", abhishek: "అభిషేక్", aditya: "ఆదిత్య", ajay: "అజయ్", ajith: "అజిత్",
  akhil: "అఖిల్", ali: "అలీ", allu: "అల్లు", amar: "అమర్", anand: "ఆనంద్", anil: "అనిల్", anjaneyulu: "ఆంజనేయులు",
  anji: "అంజి", ankit: "అంకిత్", appa: "అప్ప", appala: "అప్పల", arjun: "అర్జున్", arun: "అరుణ్", ashok: "అశోక్",
  avinash: "అవినాష్", azeem: "అజీమ్", babu: { te: "బాబు", hi: "बाबू" }, badri: "బద్రి", bala: "బాల", balaji: "బాలాజీ",
  balu: { te: "బాలు", hi: "बालू" },
  basha: "బాషా", bhanu: "భాను", bharath: "భరత్", bharat: "భరత్", bhaskar: "భాస్కర్",
  bhushan: "భూషణ్", brahma: "బ్రహ్మ", chaitanya: "చైతన్య", chakri: "చక్రి", chandra: "చంద్ర", chandu: "చందు",
  chanti: "చంటి", chinna: "చిన్న", chiranjeevi: "చిరంజీవి", chitti: "చిట్టి", dasu: "దాసు", deepak: "దీపక్",
  dhana: "ధన", dharma: "ధర్మ", dinesh: "దినేష్", durga: "దుర్గ", ganesh: "గణేష్", gopal: "గోపాల్", gopi: "గోపి",
  govind: "గోవింద్", hanuman: "హనుమాన్", hari: "హరి", harish: "హరీష్", hemanth: "హేమంత్", imran: "ఇమ్రాన్",
  ismail: "ఇస్మాయిల్", jagan: "జగన్", jagadeesh: "జగదీష్", jaya: "జయ", jayaram: "జయరాం", john: "జాన్",
  kadhar: "ఖాదర్", khader: "ఖాదర్", kalyan: "కళ్యాణ్", kamal: "కమల్", karthik: "కార్తీక్", kasim: "కాసిం",
  kiran: "కిరణ్", kishore: "కిశోర్", koti: "కోటి", krishna: "కృష్ణ", kumar: "కుమార్", lakshman: "లక్ష్మణ్",
  madhav: "మాధవ్", madhu: "మధు", mahesh: "మహేష్", malli: "మల్లి", mallikarjuna: "మల్లికార్జున", manikanta: "మణికంఠ",
  manoj: "మనోజ్", masthan: "మస్తాన్", mastan: "మస్తాన్", mohan: "మోహన్",
  mohammed: { te: "మహమ్మద్", hi: "मोहम्मद", ta: "முகமது" }, mohammad: { te: "మహమ్మద్", hi: "मोहम्मद", ta: "முகமது" },
  murali: "మురళి", murthy: "మూర్తి", naga: "నాగ", nagaraju: { te: "నాగరాజు", hi: "नागराजू" }, nagendra: "నాగేంద్ర",
  narasimha: "నరసింహ",
  narayana: "నారాయణ", naresh: "నరేష్", naveen: "నవీన్", nithin: "నితిన్", pavan: "పవన్", pawan: "పవన్", peer: "పీర్",
  prabhu: "ప్రభు", pradeep: "ప్రదీప్", prakash: "ప్రకాష్", prasad: "ప్రసాద్", prasanth: "ప్రశాంత్", prashanth: "ప్రశాంత్",
  praveen: "ప్రవీణ్", rafi: { te: "రఫీ", hi: "रफ़ी", ta: "ரஃபி" }, raghu: "రఘు", rahim: "రహీమ్", raja: "రాజా",
  rajesh: "రాజేష్", raju: { te: "రాజు", hi: "राजू" }, rakesh: "రాకేష్",
  ram: "రామ్", rama: "రామ", ramana: "రమణ", ramesh: "రమేష్", ravi: "రవి", ravindra: "రవీంద్ర",
  sai: { te: "సాయి", hi: "साई", ta: "சாய்" },
  sagar: "సాగర్", sampath: "సంపత్", sandeep: "సందీప్", sankar: "శంకర్", shankar: "శంకర్", santhosh: "సంతోష్",
  santosh: "సంతోష్", sathish: "సతీష్", satish: "సతీష్", satya: "సత్య", seenu: "శీను", sekhar: "శేఖర్",
  shekhar: "శేఖర్", shiva: "శివ", siva: "శివ", sivaji: "శివాజీ", sreenivas: "శ్రీనివాస్", srinivas: "శ్రీనివాస్",
  srinivasa: "శ్రీనివాస", srinu: "శ్రీను", sri: "శ్రీ", sridhar: "శ్రీధర్", srikanth: "శ్రీకాంత్", subba: "సుబ్బ",
  subramanyam: "సుబ్రహ్మణ్యం", sudheer: "సుధీర్", sudhir: "సుధీర్", sunil: "సునీల్", suresh: "సురేష్", surya: "సూర్య",
  teja: "తేజ", tirupathi: "తిరుపతి", uday: "ఉదయ్", umesh: "ఉమేష్", vamsi: "వంశీ", vasu: "వాసు",
  venkat: "వెంకట్", venkata: "వెంకట", venkatesh: "వెంకటేష్", venkateswara: "వెంకటేశ్వర", venu: "వేణు",
  vijay: "విజయ్", vinay: "వినయ్", vinod: "వినోద్", vishnu: "విష్ణు", yesu: "యేసు", yusuf: "యూసుఫ్",
  // Women's names; Hindi and Tamil end these with the long "a" their readers expect, and
  // Hindi with the long "ī" (लक्ष्मी, देवी).
  anitha: { te: "అనిత", hi: "अनीता", ta: "அனிதா" }, anusha: { te: "అనూష", hi: "अनुषा", ta: "அனுஷா" },
  aruna: { te: "అరుణ", hi: "अरुणा", ta: "அருணா" }, bhavani: { te: "భవాని", hi: "भवानी" },
  deepika: { te: "దీపిక", hi: "दीपिका", ta: "தீபிகா" }, devi: { te: "దేవి", hi: "देवी" },
  divya: { te: "దివ్య", hi: "दिव्या", ta: "திவ்யா" }, geetha: { te: "గీత", hi: "गीता", ta: "கீதா" },
  gowri: { te: "గౌరి", hi: "गौरी" }, haritha: { te: "హరిత", hi: "हरिता", ta: "ஹரிதா" }, jyothi: "జ్యోతి",
  kalyani: { te: "కళ్యాణి", hi: "कल्याणी" }, kavitha: { te: "కవిత", hi: "कविता", ta: "கவிதா" }, keerthi: "కీర్తి",
  kumari: { te: "కుమారి", hi: "कुमारी" }, lakshmi: { te: "లక్ష్మి", hi: "लक्ष्मी" },
  latha: { te: "లత", hi: "लता", ta: "லதா" }, madhavi: { te: "మాధవి", hi: "माधवी" },
  mounika: { te: "మౌనిక", hi: "मौनिका", ta: "மௌனிகா" }, padma: { te: "పద్మ", hi: "पद्मा", ta: "பத்மா" },
  pavani: { te: "పావని", hi: "पावनी" }, pooja: { te: "పూజ", hi: "पूजा", ta: "பூஜா" },
  priya: { te: "ప్రియ", hi: "प्रिया", ta: "பிரியா" }, radha: { te: "రాధ", hi: "राधा", ta: "ராதா" },
  rani: { te: "రాణి", hi: "रानी" }, rekha: { te: "రేఖ", hi: "रेखा", ta: "ரேகா" }, renuka: { te: "రేణుక", hi: "रेणुका", ta: "ரேணுகா" },
  sailaja: { te: "శైలజ", hi: "शैलजा", ta: "சைலஜா" }, saritha: { te: "సరిత", hi: "सरिता", ta: "சரிதா" },
  sirisha: { te: "శిరీష", hi: "शिरीषा", ta: "சிரிஷா" }, sita: { te: "సీత", hi: "सीता", ta: "சீதா" },
  seetha: { te: "సీత", hi: "सीता", ta: "சீதா" }, sravani: { te: "శ్రావణి", hi: "श्रावणी" },
  sridevi: { te: "శ్రీదేవి", hi: "श्रीदेवी" }, sunitha: { te: "సునీత", hi: "सुनीता", ta: "சுனிதா" },
  swapna: { te: "స్వప్న", hi: "स्वप्ना", ta: "ஸ்வப்னா" }, swathi: "స్వాతి", uma: { te: "ఉమ", hi: "उमा", ta: "உமா" },
  vani: { te: "వాణి", hi: "वाणी" }, vijaya: { te: "విజయ", hi: "विजया", ta: "விஜயா" },
  // Family names and the rest.
  bandi: "బండి", chowdary: "చౌదరి", chaudhary: "చౌదరి", goud: "గౌడ్",
  gupta: { te: "గుప్తా", hi: "गुप्ता", ta: "குப்தா" }, jilla: "జిల్లా", khan: "ఖాన్",
  naidu: { te: "నాయుడు", hi: "नायडू" }, patel: "పటేల్", rao: { te: "రావు", hi: "राव", ta: "ராவ்" }, sastry: "శాస్త్రి",
  setty: "శెట్టి", shetty: "శెట్టి", sharma: { te: "శర్మ", hi: "शर्मा", ta: "சர்மா" }, singh: "సింగ్", swamy: "స్వామి",
  shaik: { te: "షేక్", hi: "शेख", ta: "ஷேக்" }, sheik: { te: "షేక్", hi: "शेख", ta: "ஷேக்" }, syed: "సయ్యద్",
  valli: "వల్లి", varma: { te: "వర్మ", hi: "वर्मा", ta: "வர்மா" }, yadav: "యాదవ్",
  reddy: { te: "రెడ్డి", hi: "रेड्डी", ta: "ரெட்டி" },
  // English words in account and business names ("Sai Travels", "Test User"), said the
  // way each language says them.
  admin: "అడ్మిన్", agency: "ఏజెన్సీ", and: "అండ్", cab: "క్యాబ్", cabs: "క్యాబ్స్", car: "కార్", cars: "కార్స్",
  company: "కంపెనీ", customer: "కస్టమర్", demo: "డెమో", driver: "డ్రైవర్", enterprises: "ఎంటర్‌ప్రైజెస్",
  holidays: "హాలిడేస్", logistics: "లాజిస్టిక్స్", owner: "ఓనర్", rental: "రెంటల్", rentals: "రెంటల్స్",
  service: "సర్వీస్", services: "సర్వీసెస్", taxi: "టాక్సీ", test: "టెస్ట్", tours: "టూర్స్",
  transport: "ట్రాన్స్‌పోర్ట్", transports: "ట్రాన్స్‌పోర్ట్స్", travel: { te: "ట్రావెల్", hi: "ट्रैवल" },
  travels: { te: "ట్రావెల్స్", hi: "ट्रैवल्स" }, user: "యూజర్",
};

/* Cars: makes, models, and the words their names carry. Letter codes (VXi, AMT, SML) are
   read out letter by letter by utils/localNames; they need no entry. */
export const CAR_WORDS = {
  // A word some languages spell their own way gives those spellings.
  hyundai: { te: "హ్యుందాయ్", hi: "हुंडई", ta: "ஹூண்டாய்", kn: "ಹ್ಯುಂಡೈ" },
  diesel: { te: "డీజిల్", hi: "डीज़ल", ta: "டீசல்", kn: "ಡೀಸೆಲ್" },
  dzire: { te: "డిజైర్", hi: "डिज़ायर", ta: "டிசையர்" }, desire: { te: "డిజైర్", hi: "डिज़ायर", ta: "டிசையர்" },
  toyota: { te: "టొయోటా", ta: "டொயோட்டா" }, suzuki: { te: "సుజుకి", ta: "சுசுகி" },
  maruti: "మారుతి", swift: "స్విఫ్ట్",
  innova: "ఇన్నోవా", crysta: "క్రిస్టా", hycross: "హైక్రాస్", etios: "ఇటియోస్", fortuner: "ఫార్చ్యూనర్", glanza: "గ్లాంజా", yaris: "యారిస్",
  tata: "టాటా", altroz: "ఆల్ట్రోజ్", nexon: "నెక్సాన్", punch: "పంచ్", tiago: "టియాగో", tigor: "టిగోర్", indica: "ఇండికా",
  indigo: "ఇండిగో", sumo: "సుమో", safari: "సఫారీ", harrier: "హారియర్", baleno: "బలెనో", ertiga: "ఎర్టిగా",
  celerio: "సెలెరియో", wagon: "వ్యాగన్", alto: "ఆల్టో", eeco: "ఈకో", brezza: "బ్రెజ్జా", ciaz: "సియాజ్",
  ignis: "ఇగ్నిస్", fronx: "ఫ్రాంక్స్", grand: "గ్రాండ్", vitara: "విటారా", new: "న్యూ",
  venue: "వెన్యూ", creta: "క్రెటా", verna: "వెర్నా", aura: "ఆరా", xcent: "ఎక్సెంట్", santro: "శాంట్రో",
  alcazar: "అల్కజార్", mahindra: "మహీంద్రా", thar: "థార్", scorpio: "స్కార్పియో", bolero: "బొలెరో", xylo: "జైలో",
  marazzo: "మరాజో", kia: "కియా", carens: "కారెన్స్", seltos: "సెల్టోస్", sonet: "సోనెట్", carnival: "కార్నివాల్",
  honda: "హోండా", city: "సిటీ", amaze: "అమేజ్", jazz: "జాజ్", elevate: "ఎలివేట్", renault: "రెనో", kwid: "క్విడ్",
  triber: "ట్రైబర్", kiger: "కైగర్", nissan: "నిస్సాన్", magnite: "మాగ్నైట్", sunny: "సన్నీ", datsun: "డాట్సన్",
  ford: "ఫోర్డ్", ecosport: "ఎకోస్పోర్ట్", figo: "ఫిగో", aspire: "ఆస్పైర్", endeavour: "ఎండీవర్", chevrolet: "షెవర్లే",
  enjoy: "ఎంజాయ్", tavera: "టవేరా", beat: "బీట్", volkswagen: "ఫోక్స్‌వ్యాగన్", polo: "పోలో", vento: "వెంటో",
  skoda: "స్కోడా", rapid: "ర్యాపిడ్", hector: "హెక్టర్", series: "సిరీస్", audi: "ఆడి", mercedes: "మెర్సిడెస్",
  benz: { te: "బెంజ్", ta: "பென்ஸ்" }, force: "ఫోర్స్", traveller: "ట్రావెలర్", traveler: "ట్రావెలర్", urbania: "అర్బేనియా",
  ashok: "అశోక్", leyland: "లేలాండ్", lynx: "లింక్స్", isuzu: "ఇసుజు", eicher: "ఐషర్", tempo: "టెంపో", bus: "బస్",
  mini: "మినీ", seater: "సీటర్", seat: "సీట్", seats: "సీట్లు", str: "సీటర్", luxury: "లగ్జరీ", plus: "ప్లస్",
  prestige: "ప్రెస్టీజ్", premium: "ప్రీమియం", sport: "స్పోర్ట్", sports: "స్పోర్ట్స్", delta: "డెల్టా",
  sigma: "సిగ్మా", alpha: "ఆల్ఫా", zeta: "జీటా", petrol: "పెట్రోల్", electric: "ఎలక్ట్రిక్",
  automatic: "ఆటోమేటిక్", manual: "మాన్యువల్", mono: "మోనో", long: "లాంగ్", wheelbase: "వీల్‌బేస్",
  executive: "ఎగ్జిక్యూటివ్", execuitive: "ఎగ్జిక్యూటివ్", hirio: "హిరియో", ltd: "లిమిటెడ్", limited: "లిమిటెడ్",
  van: "వ్యాన్", winger: "వింగర్",
};

/* Places: the words place names are made of, and the areas customers pick from most. */
export const PLACE_WORDS = {
  // A word each language spells its own way gives those spellings.
  circle: { te: "సర్కిల్", hi: "सर्कल", ta: "சர்க்கிள்", kn: "ಸರ್ಕಲ್" }, road: "రోడ్", roads: "రోడ్స్", nagar: "నగర్",
  colony: "కాలనీ", street: "వీధి", bus: "బస్", stand: { te: "స్టాండ్", hi: "स्टैंड" },
  busstand: { te: "బస్ స్టాండ్", hi: "बस स्टैंड" }, station: { te: "స్టేషన్", kn: "ಸ್ಟೇಷನ್" },
  railway: { te: "రైల్వే", hi: "रेलवे", ta: "ரயில்வே", kn: "ರೈಲ್ವೆ" },
  airport: { te: "ఎయిర్‌పోర్ట్", hi: "एयरपोर्ट", ta: "ஏர்போர்ட்", kn: "ಏರ್‌ಪೋರ್ಟ್" },
  temple: "గుడి", hospital: "ఆసుపత్రి", market: "మార్కెట్", center: "సెంటర్", centre: "సెంటర్",
  junction: "జంక్షన్", cross: "క్రాస్", gate: "గేట్", bridge: "బ్రిడ్జ్", mall: "మాల్", college: "కాలేజీ",
  school: "స్కూల్", main: "మెయిన్", new: "న్యూ", old: "ఓల్డ్", urban: "అర్బన్", rural: "రూరల్", mandal: "మండలం",
  district: "జిల్లా", andhra: "ఆంధ్ర", pradesh: "ప్రదేశ్", telangana: "తెలంగాణ", india: "భారతదేశం",
  benz: { te: "బెంజ్", ta: "பென்ஸ்" }, one: { te: "వన్", ta: "ஒன்" }, two: "టూ",
  town: { te: "టౌన్", hi: "टाउन", ta: "டவுன்" }, auto: { te: "ఆటో", hi: "ऑटो", ta: "ஆட்டோ" }, singh: "సింగ్",
  gandhi: "గాంధీ", nehru: "నెహ్రూ",
  gollapudi: "గొల్లపూడి", gannavaram: "గన్నవరం", kanuru: "కానూరు", patamata: "పటమట", labbipet: "లబ్బీపేట",
  governorpet: "గవర్నర్‌పేట", moghalrajpuram: "మొగల్రాజపురం", bhavanipuram: "భవానీపురం", penamaluru: "పెనమలూరు",
  tadepalli: "తాడేపల్లి", mangalagiri: "మంగళగిరి", ibrahimpatnam: "ఇబ్రహీంపట్నం", poranki: "పోరంకి",
  enikepadu: "ఎనికేపాడు", ramavarappadu: "రామవరప్పాడు", gunadala: "గుణదల", krishna: "కృష్ణ", lanka: "లంక",
  vidhyadharapuram: "విద్యాధరపురం", vidyadharapuram: "విద్యాధరపురం", kondapalli: "కొండపల్లి", nunna: "నున్న",
  payakapuram: "పాయకాపురం", satyanarayanapuram: "సత్యనారాయణపురం", suryaraopet: "సూర్యారావుపేట",
  kankipadu: "కంకిపాడు", nidamanuru: "నిడమానూరు", ajit: "అజిత్",
};

/* Colours, word for word in each language - they are words, not names. [te, hi, ta, kn] */
export const COLOR_WORDS = {
  white: ["తెలుపు", "सफ़ेद", "வெள்ளை", "ಬಿಳಿ"],
  black: ["నలుపు", "काला", "கருப்பு", "ಕಪ್ಪು"],
  silver: ["వెండి రంగు", "सिल्वर", "வெள்ளி நிறம்", "ಬೆಳ್ಳಿ ಬಣ್ಣ"],
  grey: ["బూడిద రంగు", "स्लेटी", "சாம்பல்", "ಬೂದು"],
  gray: ["బూడిద రంగు", "स्लेटी", "சாம்பல்", "ಬೂದು"],
  red: ["ఎరుపు", "लाल", "சிவப்பு", "ಕೆಂಪು"],
  blue: ["నీలం", "नीला", "நீலம்", "ನೀಲಿ"],
  maroon: ["మెరూన్", "मैरून", "மெரூன்", "ಮರೂನ್"],
  marine: ["మెరైన్", "मरीन", "மரைன்", "ಮರೀನ್"],
  brown: ["గోధుమ రంగు", "भूरा", "பழுப்பு", "ಕಂದು"],
  green: ["ఆకుపచ్చ", "हरा", "பச்சை", "ಹಸಿರು"],
  yellow: ["పసుపు", "पीला", "மஞ்சள்", "ಹಳದಿ"],
  orange: ["నారింజ", "नारंगी", "ஆரஞ்சு", "ಕಿತ್ತಳೆ"],
  gold: ["బంగారు రంగు", "सुनहरा", "தங்க நிறம்", "ಚಿನ್ನದ ಬಣ್ಣ"],
  golden: ["బంగారు రంగు", "सुनहरा", "தங்க நிறம்", "ಚಿನ್ನದ ಬಣ್ಣ"],
  beige: ["లేత గోధుమ", "बेज", "பழுப்பு வெள்ளை", "ತಿಳಿ ಕಂದು"],
  cream: ["క్రీమ్", "क्रीम", "க்ரீம்", "ಕ್ರೀಮ್"],
  pearl: ["ముత్యపు", "मोती", "முத்து", "ಮುತ್ತಿನ"],
  dark: ["ముదురు", "गहरा", "அடர்", "ಗಾಢ"],
  light: ["లేత", "हल्का", "வெளிர்", "ತಿಳಿ"],
};

/* The letters of the English alphabet as they are read out - for codes such as VXi and
   the initials after a name ("Ravi K"). Telugu; the other scripts follow it. */
export const LETTER_NAMES = {
  a: "ఏ", b: "బి", c: "సి", d: "డి", e: "ఇ", f: "ఎఫ్", g: "జి", h: "హెచ్", i: "ఐ", j: "జె", k: "కె", l: "ఎల్", m: "ఎమ్",
  n: "ఎన్", o: "ఓ", p: "పి", q: "క్యూ", r: "ఆర్", s: "ఎస్", t: "టి", u: "యు", v: "వి", w: "డబ్ల్యు", x: "ఎక్స్",
  y: "వై", z: "జెడ్",
};
